import { Component, inject, viewChild, OnInit, signal } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { BasicDialogComponent } from '../../../../shared/components/basic-dialog/basic-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatIconModule, MatToolbarModule, MatButtonModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {
  readonly menuTrigger = viewChild.required(MatMenuTrigger);
  readonly dialog = inject(MatDialog);
  
  isMobileOrTablet = false;

  ngOnInit() {
    this.detectDevice();
  }

  private detectDevice() {
    const userAgent = navigator.userAgent;
    const screenWidth = window.innerWidth;
    
    this.isMobileOrTablet = screenWidth <= 1024 || 
                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    
    if (!this.isMobileOrTablet) {
      return;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(BasicDialogComponent);
    dialogRef.afterClosed().subscribe(() => console.log('Dialog closed'));
  }
}
